module.exports = "<h2 style=\"margin:20px;\">\n  404 Page not found!\n</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main